import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASES]: {
		url: '/company/:companyId/land_cadastral_cases/',
	},

	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASE]: {
		url: '/company/:companyId/land_cadastral_cases/:cadastralCaseId/',
	},

	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASE_PREVIEW]: {
		url: '/company/:companyId/land_cadastral_cases/:cadastralCaseId/preview/',
	},

	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].GET_LANDS_CADASTRAL_CASE_POPUP]: {
		url: '/company/:companyId/land_cadastral_cases/:cadastralCaseId/popup/',
	},


	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].CREATE_LANDS_CADASTRAL_CASE]: {
		url: '/company/:companyId/land_cadastral_cases/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].PUT_LANDS_CADASTRAL_CASE]: {
		url: '/company/:companyId/land_cadastral_cases/:cadastralCaseId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].PATCH_LANDS_CADASTRAL_CASE]: {
		url: '/company/:companyId/land_cadastral_cases/:cadastralCaseId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.LANDS_CADASTRAL_CASES].DELETE_LANDS_CADASTRAL_CASE]: {
		url: '/company/:companyId/land_cadastral_cases/:cadastralCaseId/',
		requestOptions: {
			method: 'DELETE',
		},
	},

}